import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { PrimeNGConfig } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { FileUpload } from 'primeng/fileupload';
import { UploadService } from '../../../services/upload/upload.service';
import { DmsFile } from '../../../modal/upload/model/upload.model';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
@Component({
  selector: 'app-aon',
  standalone: false,
  templateUrl: './aon.component.html',
  styleUrl: './aon.component.scss'
})
export class AONComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @Input() id: any
  commentForm: FormGroup;
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() step: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  aonSocForm!: FormGroup;
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  selectedFiles: { [key: string]: File } = {};
  uploadedAonUrl: string | null = null;
  uploadedSocUrl: string | null = null;
  uploadedSotrUrl: string | null = null;
  apiUrl = environment.APIUrl;
  aonID: any;
  selectedSOCFileName: string | null = null;
  selectedAONFileName: string | null = null;
  allDmsFiles: any[]=[];
  @ViewChild('aonUploader') aonUploader: FileUpload;
  @ViewChild('socUploader') scUploader: FileUpload;

  private subscriptions = new Subscription();
  userID: any;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  editorReady = false;

  // Committee (schemeType rev only) - same API as constitute-committee
  committees: any[] = [];
  schemes: any[] = [];
  selectedScheme: any;
  userList: any;
  committeeForm!: FormGroup;
  assignmentForm!: FormGroup;
  memberCols = [
    { field: 'slNo', header: 'Sl Number', filterType: 'text' },
    { field: 'user', header: 'Designation', filterType: 'text' },
    { field: 'role', header: 'Role', filterType: 'text' },
  ];
  addCommitteeDialog = false;
  addNewCommitteeDialog = false;
  updateCommitteDialog = false;
  selectedCommittee: any;
  editMemberDialog = false;
  deleteMember = false;
  showDeleteConfirmDialog = false;
  committeeToDelete: any = null;
  committeeDeleteIndex = -1;
  userInputMode: 'dropdown' | 'manual' = 'dropdown';
  committeeID: any;
  memberID: any;
  memberToDeleteId: any;
  /** Mode of tender from draft-rfp API; hide vendor management when "Open Tender" or "Single Tender" */
  modeOfTender: string | null = null;

  constructor(private fb: FormBuilder, private config: PrimeNGConfig, private messageService: MessageService, private api: ApiService,
    private uploadService: UploadService, 
    private route: ActivatedRoute) {
    this.commentForm = this.fb.group({
      comment: ['', Validators.required],
      vendor: ['', Validators.required],
      upload: ['', Validators.required]
    });
          const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    // this.loadDocList(); 
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      // const proposalStep = params['step'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        // proposal_step:proposalStep,
        proposal_name: proposalName
      };
      if (this.schemeType === 'rev' && this.payload?.proposal_id) {
        this.getCommittee();
        this.getUserList();
      }
    });
    this.aonSocForm = this.fb.group({
        aon_amount: [''],
        aon_date: [''],
        cfa_name: [''],
        file_number: [''],
        comment: ['', Validators.required],
        rfp: [''],
    });
    this.getAonSocDetails();
    this.updateValidatorsForSchemeType();
    if ( this.stepDetails?.can_edit || this.isEditable) {
      this.commentForm.enable();
    } else {
      this.commentForm.disable();
    }
    // Committee (schemeType rev only) - same API as constitute-committee
    this.committeeForm = this.fb.group({
      committeeName: ['', Validators.required],
    });
    this.assignmentForm = this.fb.group({
      user: [null],
      user_name: [''],
      role: ['', Validators.required],
    });
    this.updateFormValidation();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['schemeType'] && this.aonSocForm) {
      this.updateValidatorsForSchemeType();
    }
    if (changes['schemeType'] && this.schemeType === 'rev' && this.payload?.proposal_id) {
      this.getCommittee();
      if (!this.userList) this.getUserList();
    }
  }

  /**
   * For schemeType 'rev', comment (Justification) is hidden and aon_date is set at final approval.
   * So we do not require comment when schemeType is 'rev'.
   */
  private updateValidatorsForSchemeType(): void {
    if (!this.aonSocForm) return;
    const commentControl = this.aonSocForm.get('comment');
    if (!commentControl) return;
    if (this.schemeType === 'rev') {
      commentControl.clearValidators();
    } else {
      commentControl.setValidators(Validators.required);
    }
    commentControl.updateValueAndValidity();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.aonSocForm.get('comment')?.enable();
      } else {
        this.isEditorDisabled = true;
        this.aonSocForm.get('comment')?.disable();
      }
      this.rebuildEditor();
    }, 3000);
  }

  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }

  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled
    };
  }
  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
  expandedSections: { [key: string]: boolean } =
  {
    basicInfo: true,
    equipment: false,
    quantity: false,
    cost: false,
    detailedInfo: false,
    uploads: false,
    vendorTable: false
  };
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  //     aonId: number | null = null;

  //     loadDocList() {
  //       const url = `/revenue/aon-details/?proposal_step=${this.id}`;
  //       this.api.getAPI(url).subscribe({
  //         next: (res: any) => {
  //           if (res && res.aon_data?.length) {
  //             const first = res.aon_data[0];

  //             // Store existing AON ID
  //             this.aonId = first.id;

  //             this.commentForm.get('comment')?.setValue(first.comment);

  //             this.soc1Formate = (first.categorisation_list instanceof Array)
  //               ? first.categorisation_list.map((item: any) => ({
  //                   name: item.category,
  //                   value: item.remarks,
  //                   edit: false
  //                 }))
  //               : Object.entries(first.categorisation_list || {}).map(([key, value]) => ({
  //                   name: key,
  //                   value: value,
  //                   edit: false
  //                 }));

  //             this.docList = res.documents || [];
  //           } else {
  //             this.aonId = null;
  //           }
  //         },
  //         error: err => {
  //           this.messageService.add({
  //             severity: 'error',
  //             summary: 'Error',
  //             detail: 'Could not load documents',
  //             life: 3000
  //           });
  //         }
  //       });
  //     }






  //   filterVendor(event: AutoCompleteCompleteEvent) {
  //     let filtered: any[] = [];
  //     let query = event.query;

  //     for (let i = 0; i < (this.venderList as any[]).length; i++) {
  //         let country = (this.venderList as any[])[i];
  //         if (country.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
  //             filtered.push(country);
  //         }
  //     }

  //     this.venderList = filtered;
  // }

  // onUpload(event: any) {
  //   console.log(event);
  // }

  // soc1Formate:any[]=[];

  // addRow() {
  //   const newRow = {
  //     name: '',
  //     value: '',
  //     editable: true
  //   };
  //   this.soc1Formate.unshift(newRow);
  // }



  // saveRow(product: any){
  //   product.edit = false;
  // }
  // submitAONComment() {
  //   const categorisation_list: any[] = [];

  //   this.soc1Formate.forEach(item => {
  //     if (item.name?.trim() && item.value?.trim()) {
  //       categorisation_list.push({
  //         category: item.name.trim(),
  //         remarks: item.value.trim(),
  //         sub_category: '' 
  //       });
  //     }
  //   });

  //   const payload = {
  //     proposal_step: this.id,
  //     comment: this.commentForm.value.comment,
  //     categorisation_list
  //   };

  //   const url = `/revenue/aon-details/`;

  //   if (this.aonId) {
  //     // PUT update
  //     this.api.putAPI(`${url}${this.aonId}/`, payload).subscribe({
  //       next: (res: any) => {
  //         this.messageService.add({
  //           severity: 'success',
  //           summary: 'Updated successfully',
  //           detail: res.message || 'Comment updated'
  //         });
  //         this.loadDocList();
  //       },
  //       error: () => {
  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Update failed',
  //           detail: 'Failed to update comment'
  //         });
  //       }
  //     });
  //   } else {
  //     //  POST create
  //     this.api.postAPI(url, payload).subscribe({
  //       next: (res: any) => {
  //         this.messageService.add({
  //           severity: 'success',
  //           summary: 'Submitted successfully',
  //           detail: res.message || 'Comment submitted'
  //         });
  //         this.loadDocList();
  //       },
  //       error: () => {
  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Submission failed',
  //           detail: 'Could not submit comment'
  //         });
  //       }
  //     });
  //   }
  // }
  onFileSelect(event: any, type: 'aon' | 'rfp') {
    const file = event.files[0];
    if (type === 'rfp' && event.files && event.files.length > 0) {
    this.selectedSOCFileName = event.files[0].name;
  }
  if (type === 'aon' && event.files && event.files.length > 0) {
    this.selectedAONFileName = event.files[0].name;
  }
    if (file) {
      this.selectedFiles[type] = file;
      

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: `${type.toUpperCase()} file attached successfully`
      });
    }
  }

  onSubmit() {
    if (this.aonSocForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation Error',
        detail: 'Please fill out required fields before saving.',
      });
      return;
    }

    const formData = new FormData();
    formData.append('proposal_step', this.step.id);
    formData.append('aon_amount', this.aonSocForm.get('aon_amount')?.value || '');
    formData.append('aon_date', this.aonSocForm.get('aon_date')?.value || '');
    formData.append('cfa_name', this.aonSocForm.get('cfa_name')?.value || '');
    formData.append('file_number', this.aonSocForm.get('file_number')?.value || '');
    formData.append('comment', this.aonSocForm.get('comment')?.value || '');

    if (this.selectedFiles?.['aon']) {
      formData.append('aon', this.selectedFiles['aon']);
    }

    if (this.selectedFiles?.['rfp']) {
      formData.append('rfp', this.selectedFiles['rfp']);
    }

    if (this.aonID) {
      const sub = this.api.putAPI(`/revenue/aon-details/${this.aonID}/`, formData).subscribe({
        next: (res) => {
          this.messageService.add({ severity: 'success', summary: 'Submitted', detail: 'From Save successfully' });
          // Clear uploaded files if needed
          this.selectedFiles = null;
          this.selectedSOCFileName = null;
          this.selectedAONFileName = null;
          if (this.aonUploader) this.aonUploader.clear();
          if (this.scUploader) this.scUploader.clear();
          this.getAonSocDetails();
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Upload failed' });
        }
      });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api.postAPI('/revenue/aon-details/', formData).subscribe({
        next: (res) => {
          this.getAonSocDetails();
          this.messageService.add({ severity: 'success', summary: 'Submitted', detail: 'From Save successfully' });
          // Clear uploaded files if needed
          if (this.scUploader) this.scUploader.clear();
          if (this.aonUploader) this.aonUploader.clear();
          this.selectedFiles = null;
          this.selectedSOCFileName = null;
          this.selectedAONFileName = null;
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Upload failed' });
        }
      });
      this.subscriptions.add(sub);
    }
  }

  getAonSocDetails() {
    const sub = this.api.getAPI(`/revenue/aon-details/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`).subscribe({
      next: (res: any) => {
        console.log('AON res',res);
        const dataAON = res?.data || res;
        const dmsFiles: DmsFile[] = dataAON?.dms_files || [];
        this.allDmsFiles = dmsFiles;
        // this.uploadedAonUrl = res[0]?.aon || null;
        // this.uploadedSocUrl = res[0]?.rfp || null;
        // this.aonID = res[0]?.id;
        this.uploadedAonUrl = res.data?.aon || null;
        this.uploadedSocUrl = res?.soc || null;
        this.uploadedSotrUrl = res?.sotr || null;
        this.aonID = res.data?.id;
        this.modeOfTender = res?.mode_tendor ??  null;
         this.aonSocForm.patchValue({
          //  aon_amount: res[0].aon_amount || '',
          //  aon_date:  res[0].aon_date || '',
          //  cfa_name:  res[0].cfa_name || '',
          //  file_number:  res[0].file_number || '',
          //  comment: res[0]?.comment || '',
           aon_amount: res.data.aon_amount || '',
           aon_date:  res.data.aon_date || '',
           cfa_name:  res.data.cfa_name || '',
           file_number:  res.data.file_number || '',
           comment: res.data?.comment || '',
           rfp: res?.rfp || ''
         });
        this.documentsForManagement = this.buildDocumentsForManagement();
      },
      error: (err) => { }
    })
    this.subscriptions.add(sub);
  }

   /** True when vendor management (upload vendor files) should be hidden (Open Tender / Single Tender). */
  get hideVendorManagement(): boolean {
    const m = (this.modeOfTender || '').trim();
    return m === 'Open Tender' || m === 'Single Tender' || m === 'Open Tinder';
  }

  /** Extract display filename from file path (e.g. /media/.../file.pdf -> file.pdf). */
  getFileName(path: string | null | undefined): string {
    if (!path) return '';
    const parts = path.replace(/\\/g, '/').split('/');
    return parts[parts.length - 1] || path;
  }

  /** DMS list for Document Management table: dms_files from API + SOC and SOTR when present. */
  documentsForManagement: any[] = [];

  private buildDocumentsForManagement(): any[] {
    const list = [...(this.allDmsFiles || [])];
    if (this.uploadedSocUrl) {
      list.push({
        id: null,
        name: 'SOC',
        description: 'Statement of Compliance',
        type_document: '',
        uploaded_at: '',
        file: this.uploadedSocUrl,
        is_approved: false,
        document_flag: false,
        proposal_step: this.stepDetails?.id || this.step?.id,
      });
    }
    if (this.uploadedSotrUrl) {
      list.push({
        id: null,
        name: 'SOTR',
        description: 'Statement of Technical Readiness',
        type_document: '',
        uploaded_at: '',
        file: this.uploadedSotrUrl,
        is_approved: false,
        document_flag: false,
        proposal_step: this.stepDetails?.id || this.step?.id,
      });
    }
    return list;
  }

        // this is use for upload document table


  goToNextStep() {
    this.stepCompleted.emit();
  }

  generatePDF() {
    const data: any[] = [
      { key: 'Proposal Name', value: this.payload.proposal_name },
      { key: 'AON Amount', value: this.aonSocForm.get('aon_amount')?.value || '' },
      { key: 'AON Date', value: this.aonSocForm.get('aon_date')?.value || '' },
      { key: 'CFA Name', value: this.aonSocForm.get('cfa_name')?.value || '' },
      { key: 'File Number', value: this.aonSocForm.get('file_number')?.value || '' },
      { key: 'Justification', value: this.aonSocForm.get('comment')?.value || '' },
    ];

    const payload = {
      url: '/revenue/need/version-control/',
      data,
    };

    this.generatePDFEmitter.emit(payload);
  }

  clearUpload() {
    if (this.aonUploader) this.aonUploader.clear();
    if (this.scUploader) this.scUploader.clear();
  }

  // Vendor Management Event Handlers
  onVendorAdded(event: any): void {
    console.log('Vendor added:', event);
  }

  onVendorUpdated(event: any): void {
    console.log('Vendor updated:', event);
  }

  onVendorDeleted(event: any): void {
    console.log('Vendor deleted:', event);
  }

  onFilesSubmitted(event: any): void {
    console.log('Files submitted:', event);
  }

  /**
   * For schemeType 'rev', sets AoN Date to current date at final approval.
   * Called by parent (e.g. transaction) before onSubmit when user confirms Save/Route.
   */
  setAonDateForFinalApproval(): void {
    if (this.schemeType === 'rev') {
      const today = new Date().toISOString().split('T')[0];
      this.aonSocForm.patchValue({ aon_date: today });
    }
  }

  // ---------- Committee (schemeType rev only) - same API as constitute-committee ----------
  updateFormValidation(): void {
    if (this.userInputMode === 'dropdown') {
      this.assignmentForm.get('user_name')?.setValue('');
      this.assignmentForm.get('user_name')?.clearValidators();
      this.assignmentForm.get('user_name')?.updateValueAndValidity();
      this.assignmentForm.get('user')?.setValidators(Validators.required);
      this.assignmentForm.get('user')?.updateValueAndValidity();
    } else {
      this.assignmentForm.get('user')?.setValue(null);
      this.assignmentForm.get('user')?.clearValidators();
      this.assignmentForm.get('user')?.updateValueAndValidity();
      this.assignmentForm.get('user_name')?.setValidators(Validators.required);
      this.assignmentForm.get('user_name')?.updateValueAndValidity();
    }
  }

  onUserInputModeChange(): void {
    this.updateFormValidation();
  }

  getCommittee(): void {
    if (!this.payload?.proposal_id) return;
    const sub = this.api
      .getAPI(`/transaction/committee/?proposal=${this.payload.proposal_id}`)
      .subscribe((res: any) => {
        this.api.getAPI(`/master/committee/`).subscribe((masterRes: any) => {
          this.schemes = masterRes.data || [];
        });
        if (res.length === 0) {
          this.committees = [];
        } else {
          this.committees = res;
          this.committees.forEach((committee: any) => {
            if (committee.members && Array.isArray(committee.members)) {
              committee.members = committee.members.map((member: any, index: number) => ({
                ...member,
                slNo: index + 1,
                user: member.user_name || member.user || '',
              }));
            }
          });
        }
      });
    this.subscriptions.add(sub);
  }

  getUserList(): void {
    const sub = this.api.getAPI('/account/users/').subscribe((res: any) => {
      this.userList = res.results?.data || res.data;
    });
    this.subscriptions.add(sub);
  }

  loadSchemeCommittees(event?: any): void {
    if (event?.value) this.selectedScheme = event.value;
    if (!this.selectedScheme) return;
    const committeeId = this.selectedScheme.id || this.selectedScheme.value || this.selectedScheme.committee_id;
    if (!committeeId) return;
    const sub = this.api
      .getAPI(`/master/committee/member/?committee=${committeeId}`)
      .subscribe(() => {});
    this.subscriptions.add(sub);
  }

  openAddNewCommitteeDialog(): void {
    this.committeeForm.reset();
    this.addNewCommitteeDialog = true;
  }

  onCommitteeSubmit(): void {
    if (!this.committeeForm.valid || !this.payload?.proposal_id) return;
    const payload = {
      proposal: this.payload.proposal_id,
      name: this.committeeForm.get('committeeName')?.value?.trim(),
    };
    const sub = this.api.postAPI('/transaction/committee/', payload).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Committee added successfully' });
        this.addNewCommitteeDialog = false;
        this.committeeForm.reset();
        this.getCommittee();
      },
      error: (err: any) => {
        const msg = err?.error?.detail || err?.error?.message || 'Failed to add committee.';
        this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
      },
    });
    this.subscriptions.add(sub);
  }

  addFromExisting(): void {
    if (!this.selectedScheme) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a committee from the dropdown first.' });
      return;
    }
    const committeeId = this.selectedScheme.id || this.selectedScheme.value || this.selectedScheme.committee_id;
    if (!committeeId) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Selected committee is missing required information.' });
      return;
    }
    if (!this.payload?.proposal_id) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Proposal information is not available.' });
      return;
    }
    const committeeName = this.selectedScheme.name || this.selectedScheme.label || this.selectedScheme.committee_name;
    const payload = {
      proposal: this.payload.proposal_id,
      name: committeeName,
      committe_master: committeeId,
    };
    const sub = this.api.postAPI('/transaction/committee/', payload).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Committee added successfully' });
        this.selectedScheme = null;
        this.getCommittee();
        this.assignmentForm.reset();
      },
      error: (err: any) => {
        const msg = err?.error?.detail || err?.error?.message || 'Failed to add committee.';
        this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
      },
    });
    this.subscriptions.add(sub);
  }

  openAddCommittee(committee: any): void {
    this.committeeForm.reset();
    this.assignmentForm.reset();
    this.userInputMode = 'dropdown';
    this.committeeID = committee.id;
    this.updateFormValidation();
    this.addCommitteeDialog = true;
  }

  onAssignmentSubmit(): void {
    if (!this.assignmentForm.valid) return;
    let payload: any = {
      committee_id: this.committeeID,
      role: this.assignmentForm.get('role')?.value,
    };
    if (this.userInputMode === 'dropdown' && this.assignmentForm.get('user')?.value) {
      payload.user_id = this.assignmentForm.get('user')?.value.id;
    } else if (this.userInputMode === 'manual' && this.assignmentForm.get('user_name')?.value) {
      payload.user_name = this.assignmentForm.get('user_name')?.value.trim();
    }
    const sub = this.api.postAPI('/transaction/committee/member/', payload).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Committee added successfully' });
        this.addCommitteeDialog = false;
        this.getCommittee();
        this.assignmentForm.reset();
        this.userInputMode = 'dropdown';
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save mapping.' });
      },
    });
    this.subscriptions.add(sub);
  }

  updateCommittemeber(member: any, committee: any): void {
    const matchedUser = this.userList?.find((u: any) => u.loginname === member.user);
    if (matchedUser) {
      this.userInputMode = 'dropdown';
      this.assignmentForm.patchValue({ user: matchedUser, user_name: '', role: member.role });
    } else {
      this.userInputMode = 'manual';
      this.assignmentForm.patchValue({ user: null, user_name: member.user_name || member.user || '', role: member.role });
    }
    this.committeeID = committee.id;
    this.memberID = member.id;
    this.editMemberDialog = true;
    this.updateFormValidation();
  }

  onAssignmentUpdateSubmit(): void {
    if (!this.assignmentForm.valid) return;
    let payload: any = {
      committee_id: this.committeeID,
      role: this.assignmentForm.get('role')?.value,
    };
    if (this.userInputMode === 'dropdown' && this.assignmentForm.get('user')?.value) {
      payload.user_id = this.assignmentForm.get('user')?.value.id;
    } else if (this.userInputMode === 'manual' && this.assignmentForm.get('user_name')?.value) {
      payload.user_name = this.assignmentForm.get('user_name')?.value.trim();
    }
    const sub = this.api.putAPI(`/transaction/committee/member/${this.memberID}/`, payload).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Committee member updated successfully' });
        this.getCommittee();
        this.assignmentForm.reset();
        this.userInputMode = 'dropdown';
        this.editMemberDialog = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save mapping.' });
      },
    });
    this.subscriptions.add(sub);
  }

  showDeletePopup(memberRow: any): void {
    this.deleteMember = true;
    this.memberToDeleteId = memberRow.id;
  }

  ConfirmMemberDelete(): void {
    const sub = this.api.deleteAPI(`/transaction/committee/member/${this.memberToDeleteId}/`).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Member Deleted Successfully' });
        this.deleteMember = false;
        this.getCommittee();
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete.' });
      },
    });
    this.subscriptions.add(sub);
  }

  openDeleteDialog(committee: any, index: number): void {
    this.committeeToDelete = committee;
    this.committeeDeleteIndex = index;
    this.showDeleteConfirmDialog = true;
  }

  confirmDeleteCommittee(): void {
    const id = this.committeeToDelete?.id;
    if (id == null) return;
    const sub = this.api.deleteAPI(`/transaction/committee/${id}/`).subscribe({
      next: () => {
        this.committees.splice(this.committeeDeleteIndex, 1);
        this.messageService.add({ severity: 'success', summary: 'Deleted', detail: 'Committee removed successfully.' });
        this.getCommittee();
        this.showDeleteConfirmDialog = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete committee.' });
        this.showDeleteConfirmDialog = false;
      },
    });
    this.subscriptions.add(sub);
  }

  updateCommitte(data: any): void {
    this.updateCommitteDialog = true;
    this.selectedCommittee = data;
    setTimeout(() => {
      this.committeeForm.patchValue({ committeeName: this.selectedCommittee?.name });
    }, 0);
  }

  updateSubmit(): void {
    if (!this.committeeForm.valid || !this.selectedCommittee) return;
    const payload = {
      proposal: this.payload.proposal_id,
      name: this.committeeForm.get('committeeName')?.value,
    };
    const sub = this.api.putAPI(`/transaction/committee/${this.selectedCommittee.id}/`, payload).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Committee updated successfully' });
        this.updateCommitteDialog = false;
        this.getCommittee();
        this.committeeForm.reset();
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save.' });
      },
    });
    this.subscriptions.add(sub);
  }
}

